var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ObjectSchemaService = /** @class */ (function (_super) {
            __extends(ObjectSchemaService, _super);
            function ObjectSchemaService(injectedBreeze, $q, schemaPropertyService) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.schemaPropertyService = schemaPropertyService;
                return _this;
            }
            ObjectSchemaService.prototype.getObjectSchema = function (id) {
                return this.fetchById(id, "ObjectSchema");
            };
            ObjectSchemaService.prototype.getObjectSchemaExpanded = function (id) {
                var d = this.$q.defer();
                if (!id) {
                    d.resolve(null);
                    return d.promise;
                }
                var parameters = {
                    objectSchemaId: id
                };
                var query = this.breezeModule.EntityQuery
                    .from("ObjectSchemaExpanded")
                    .withParameters(parameters);
                this.executeQuery(query).then(function (groups) { return d.resolve(groups[0]); });
                return d.promise;
            };
            ObjectSchemaService.prototype.createNewObjectSchema = function () {
                var newObjectSchema = this.createNewEntity("ObjectSchema");
                newObjectSchema.isList = false;
                newObjectSchema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return newObjectSchema;
            };
            ObjectSchemaService.prototype.createNewListObjectSchema = function () {
                var newObjectSchema = this.createNewEntity("ObjectSchema");
                newObjectSchema.isList = true;
                newObjectSchema.uniqueIdentifier = services.UtilityService.generateGuidComb();
                return newObjectSchema;
            };
            ObjectSchemaService.prototype.validateObjectSchema = function (objectSchema) {
                var _this = this;
                var results = [];
                if (objectSchema && objectSchema.properties) {
                    objectSchema.properties.forEach(function (property) {
                        results = results.concat(_this.validateSchemaProperty(property));
                    });
                }
                return results;
            };
            ObjectSchemaService.prototype.cloneObjectSchema = function (objectSchema, schemaPropertyId) {
                var _this = this;
                var obj = this.createNewObjectSchema();
                obj.name = objectSchema.name;
                obj.dataSource_id = objectSchema.dataSource_id;
                obj.formUniqueId = objectSchema.formUniqueId;
                obj.isList = objectSchema.isList;
                obj.clonedFromId = objectSchema.id;
                if (schemaPropertyId) {
                    obj.schemaProperty_id = schemaPropertyId;
                }
                obj.uniqueIdentifier = services.UtilityService.generateGuidComb();
                objectSchema.properties.forEach(function (prop) {
                    obj.properties.push(_this.cloneSchemaProperty(prop));
                });
                return obj;
            };
            ObjectSchemaService.prototype.cloneSchemaProperty = function (property) {
                var prop = this.schemaPropertyService.createNewSchemaProperty();
                prop.propertyType = property.propertyType;
                prop.name = property.name;
                prop.codeGroup_id = property.codeGroup_id;
                prop.isIndexed = property.isIndexed;
                prop.isSystemLevel = property.isSystemLevel;
                prop.scheduledResourceConfiguration_id = property.scheduledResourceConfiguration_id;
                prop.systemVariable_id = property.systemVariable_id;
                prop.type_id = property.type_id;
                prop.uniqueIdentifier = services.UtilityService.generateGuidComb();
                prop.clonedFromId = property.id;
                if (property.typeSchema) {
                    prop.typeSchema = this.cloneObjectSchema(property.typeSchema, property.id);
                }
                return prop;
            };
            ObjectSchemaService.prototype.validateSchemaProperty = function (schemaProperty) {
                var results = [];
                if (services.UtilityService.isNullOrWhiteSpace(schemaProperty.name)) {
                    results.push("The Name field cannot be empty.");
                }
                if (schemaProperty.propertyType === null) {
                    results.push("A Variable Type must be selected from the drop down.");
                }
                if (schemaProperty.propertyType === 24 /* Code */ && schemaProperty.codeGroup === null) {
                    results.push("A Code Group must be selected for Code Variable Types. Variable with missing code group: " + schemaProperty.name ? schemaProperty.name : "Un-Named");
                }
                if (schemaProperty.typeSchema) {
                    results = results.concat(this.validateObjectSchema(schemaProperty.typeSchema));
                }
                return results;
            };
            return ObjectSchemaService;
        }(services.DataService));
        services.ObjectSchemaService = ObjectSchemaService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("ObjectSchemaService", ["breeze", "$q", "schemaPropertyService"]);
